import { NgxCurrencyConfig } from 'ngx-currency';

const currencyConfigs = new Map<string, Partial<NgxCurrencyConfig>>([
  [
    'ALL',
    { prefix: '', suffix: ' L', thousands: '.', decimal: ',', precision: 2 },
  ],
  [
    'BAM',
    { prefix: '', suffix: ' KM', thousands: '.', decimal: ',', precision: 2 },
  ],
  [
    'BGN',
    { prefix: '', suffix: ' лв', thousands: ' ', decimal: ',', precision: 2 },
  ],
  [
    'BYN',
    { prefix: '', suffix: ' Br', thousands: ' ', decimal: ',', precision: 2 },
  ],
  [
    'CHF',
    { prefix: 'CHF ', suffix: '', thousands: "'", decimal: '.', precision: 2 },
  ],
  [
    'CZK',
    { prefix: '', suffix: ' Kč', thousands: ' ', decimal: ',', precision: 2 },
  ],
  [
    'DKK',
    { prefix: '', suffix: ' kr', thousands: '.', decimal: ',', precision: 2 },
  ],
  [
    'EUR',
    { prefix: '€', suffix: '', thousands: '.', decimal: ',', precision: 2 },
  ],
  [
    'HUF',
    { prefix: '', suffix: ' HUF', thousands: ' ', decimal: ',', precision: 0 },
  ],
  [
    'ISK',
    { prefix: '', suffix: ' kr', thousands: '.', decimal: ',', precision: 0 },
  ],
  [
    'MKD',
    { prefix: '', suffix: ' ден', thousands: '.', decimal: ',', precision: 2 },
  ],
  [
    'NOK',
    { prefix: '', suffix: ' kr', thousands: ' ', decimal: ',', precision: 2 },
  ],
  [
    'PLN',
    { prefix: '', suffix: ' zł', thousands: ' ', decimal: ',', precision: 2 },
  ],
  [
    'RON',
    { prefix: '', suffix: ' lei', thousands: '.', decimal: ',', precision: 2 },
  ],
  [
    'RSD',
    { prefix: '', suffix: ' дин.', thousands: '.', decimal: ',', precision: 2 },
  ],
  [
    'SEK',
    { prefix: '', suffix: ' kr', thousands: ' ', decimal: ',', precision: 2 },
  ],
  [
    'TRY',
    { prefix: '₺', suffix: '', thousands: '.', decimal: ',', precision: 2 },
  ],
  [
    'UAH',
    { prefix: '', suffix: ' ₴', thousands: ' ', decimal: ',', precision: 2 },
  ],
]);

export function getCurrencyConfig(code: string): Partial<NgxCurrencyConfig> {
  return (
    currencyConfigs.get(code) ?? {
      prefix: '€',
      suffix: '',
      thousands: '.',
      decimal: ',',
      precision: 2,
    }
  );
}

export function formatCurrency(
  amount: number | null | undefined,
  currencyCode: string,
): string {
  if (amount === null || amount === undefined || isNaN(amount)) {
    return '';
  }

  const config = getCurrencyConfig(currencyCode);
  const prefix = config.prefix ?? '';
  const suffix = config.suffix ?? '';
  const thousands = config.thousands ?? '.';
  const decimal = config.decimal ?? ',';
  const precision = config.precision ?? 2;

  const isNegative = amount < 0;
  const absoluteAmount = Math.abs(amount);

  const fixed = absoluteAmount.toFixed(precision);
  const parts = fixed.split('.');
  const integerPart = parts[0];
  const decimalPart = parts.length > 1 ? parts[1] : '';

  const integerWithThousands = integerPart.replace(
    /\B(?=(\d{3})+(?!\d))/g,
    thousands,
  );

  let result = integerWithThousands;
  if (precision > 0) {
    result += decimal + decimalPart;
  }

  return (isNegative ? '-' : '') + prefix + result + suffix;
}
